import { createContext, ReactNode, useContext } from 'react';

import { State } from '../../../types/chat';

type Props = {
  state?: State;
  setClient: () => void;
  setLoading: (loading: boolean) => void;
  setChannel: () => void;
  sendMessage: () => void;
  addReaction: () => void;
  startThread: () => void;
  startListening: () => void;
  sendListeningMessage: () => void;
};

type ProviderProps = {
  children: ReactNode | undefined;
  state: State;
  value: {
    setClient: () => void;
    setLoading: (loading: boolean) => void;
    setChannel: () => void;
    sendMessage: () => void;
    addReaction: () => void;
    startThread: () => void;
    startListening: () => void;
    sendListeningMessage: () => void;
  };
};

const ChatContext = createContext<Props>({
  state: undefined,
  setClient: () => null,
  setLoading: () => null,
  setChannel: () => null,
  sendMessage: () => null,
  addReaction: () => null,
  startThread: () => null,
  startListening: () => null,
  sendListeningMessage: () => null,
});

export const ChatContextProvider = ({
  children,
  state,
  value,
}: ProviderProps) => {
  return (
    <ChatContext.Provider
      value={{
        state,
        ...value,
      }}
    >
      {children}
    </ChatContext.Provider>
  );
};

export const useChatContext = () => useContext(ChatContext);
